import { render } from "./ClosetHomeView.vue?vue&type=template&id=0745304a&ts=true"
import script from "./ClosetHomeView.vue?vue&type=script&lang=ts"
export * from "./ClosetHomeView.vue?vue&type=script&lang=ts"

import "./ClosetHomeView.vue?vue&type=style&index=0&id=0745304a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__